import AdminGiftRequests from "@pages/admin/gift-requests";
import AdminGifts from "@pages/admin/gifts";
import GiftForm from "@pages/admin/gifts/form";
import React from "react";
import Invoices from "@pages/admin/invoices";
import InvoiceDetail from "@pages/admin/invoices/InvoiceDetail";
import EditInvoice from "@pages/admin/invoices/EditInvoice";
import GenerateInvoice from "@pages/admin/invoices/GenerateInvoice";
import CredentialsSettings from "@pages/admin/credentials/CredentialsSettings";
import BillingConfig from "@pages/admin/billing/BillingConfig";
import AiConfiguration from "@pages/admin/ai-configuration/aiConfiguration";
import ManageCompany from "@pages/admin/companies/manageCompany";

const Adminhome = React.lazy(() => import("@pages/admin/index"));
const GestionUser = React.lazy(() => import("@pages/admin/users/index"));
const GestionSanction = React.lazy(() =>
  import("@pages/admin/sanctions/index")
);
export const adminRoutes = [
  { element: <Adminhome />, index: true },
  {
    path: "/admin/credentials",
    element: <CredentialsSettings />
  },
  { path: "/admin/sanctions", element: <GestionSanction /> },
  { path: "/admin/facturation/configuration", element: <BillingConfig  /> },
  { path: "/admin/users", element: <GestionUser /> },
  {
    path: "/admin/factures",
    element: <Invoices />,
  },
  {
    path: "/admin/factures/:id",
    element: <InvoiceDetail />,
  },
  {
    path: "/admin/factures/:id/edit",
    element: <EditInvoice />,
  },
  {
    path: "/admin/factures/generate",
    element: <GenerateInvoice />,
  },

  {
    path: "/admin/gift-requests",
    element: <AdminGiftRequests />
  },
  {
  path: "/admin/gifts",
  element: <AdminGifts />
},
{
  path: "/admin/gifts/new",
  element: <GiftForm />
},
{
  path: "/admin/gifts/edit/:id",
  element: <GiftForm />
},
{
  path: "/admin/ai",
  element: <AiConfiguration /> },
{
  path: "/admin/company",
  element: <ManageCompany /> },
];
